import { NgModule } from '@angular/core';
import { PerfectScrollbarComponent } from './perfect-scrollbar.component';

@NgModule({
  declarations: [PerfectScrollbarComponent],
  exports: [PerfectScrollbarComponent]
})
/***
 * @deprecated
 * Don't use it in the new code. This is just a workaround.
 * Since ngx-perfect-scrollbar package is no longer maintained, it's removed from the platform.
 * And due to wide usage of this component there was implemented this workaround instead.
 * But eventually it must be removed from everywhere.
 */
export class PerfectScrollbarModule {}
